import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  setGlobalSearchFilterOptions as setGlobalSearchFilterOptionsAction,
  setOutreachSimulationUpdatedFilterData as setOutreachSimulationUpdatedFilterDataAction,
  selectGlobalSearchFilterOptions,
  selectOutreachSimulationUpdatedFilterData
} from '../slices/globalSearchSlice'

export const useGlobalSearch = () => {
  const dispatch = useDispatch()

  const globalSearchFilterOptions = useSelector(selectGlobalSearchFilterOptions)
  const outreachSimulationUpdatedFilterData = useSelector(selectOutreachSimulationUpdatedFilterData)

  // Wrapper functions to maintain the same API as useImmer
  // These accept either a new value or an updater function (for Immer compatibility)
  const setGlobalSearchFilterOptions = useCallback(
    (updater) => {
      if (typeof updater === 'function') {
        // If it's a function (Immer draft updater), create a copy and apply changes
        const draft = Array.isArray(globalSearchFilterOptions)
          ? [...globalSearchFilterOptions]
          : {...globalSearchFilterOptions}
        const newState = updater(draft)
        // If the updater doesn't return anything (Immer pattern), use the mutated draft
        dispatch(setGlobalSearchFilterOptionsAction(newState === undefined ? draft : newState))
      } else {
        // Direct value assignment
        dispatch(setGlobalSearchFilterOptionsAction(updater))
      }
    },
    [dispatch, globalSearchFilterOptions]
  )

  const setOutreachSimulationUpdatedFilterData = useCallback(
    (updater) => {
      if (typeof updater === 'function') {
        // If it's a function (Immer draft updater), create a copy and apply changes
        const draft = Array.isArray(outreachSimulationUpdatedFilterData)
          ? [...outreachSimulationUpdatedFilterData]
          : {...outreachSimulationUpdatedFilterData}
        const newState = updater(draft)
        // If the updater doesn't return anything (Immer pattern), use the mutated draft
        dispatch(setOutreachSimulationUpdatedFilterDataAction(newState === undefined ? draft : newState))
      } else {
        // Direct value assignment
        dispatch(setOutreachSimulationUpdatedFilterDataAction(updater))
      }
    },
    [dispatch, outreachSimulationUpdatedFilterData]
  )

  // Return the same API as the original provider
  return {
    globalSearchFilterOptions,
    outreachSimulationUpdatedFilterData,
    setGlobalSearchFilterOptions,
    setOutreachSimulationUpdatedFilterData
  }
}
